<template>
  <div class="minheight100" style="padding-bottom: 130px; background-color: #f7f9fb">
    <app-header v-if="appUser.isNative" title="友邻少年"></app-header>
    <div style="margin-top: 20px">
      <div class="flexdiv average tjmbg" style="">
        <div>我的推荐码</div>
        <div class="flexdiv average">
          <div class="tjmtxt">{{ recommendCode }}</div>
          <div
            class="btn-common"
            style="padding: 12px 15px; margin-left: 15px; border-radius: 4px"
            @click="copyText($event)"
          >
            复制
          </div>
        </div>
      </div>
      <div class="my-swiper" v-if="recommendCode">
        <swiper :options="swiperOption" ref="mySwiper" class="swiper">
          <swiper-slide v-for="(item, index) in dataShareDetail.canvasObj" :key="index" class="swiper_item">
            <div :id="'capture' + index" style="height: 100%" v-if="item.picUrl && recommendCode">
              <img
                v-if="item.isGenerate === true"
                style="position: absolute; z-index: 100; top: 0; left: 0; opacity: 0"
                class="cover"
                crossorigin="anonymous"
                :src="item.canvasUrl"
                alt=""
              />

              <img :src="item.picUrl" @load="onImageLoad(index)" crossorigin="anonymous" />
              <div class="qrcode" v-if="recommendCode">
                {{ recommendCode }}
              </div>
            </div>
          </swiper-slide>

          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="longpress">
          <span class="icon-zhiwen"></span>
          长按并保存图片，分享到微博、小红书等平台
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Body from '@/mixins/body'
import html2canvas from 'html2canvas'
import { mapGetters } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { activityService } from '@/api'
import QRCode from 'qrcode'
import { toLoginView } from '@/utils/init/env-init'
import { Toast, Dialog } from 'vant'
import { appUser } from '@/utils'
import { saTrack } from '@/utils/common/shence'
import { MessageBox } from 'mint-ui'
import copyText from '@/utils/clipboard'

const action = 'activityRecommend'

export default {
  name: '',
  components: {
    swiper: swiper,
    swiperSlide: swiperSlide,
    'van-dialog': Dialog.Component
  },
  data() {
    return {
      appUser,
      title: '',
      activityId: '',
      shareUserId: appUser.userId,
      dialogShow: false,
      shareLoading: false,
      dataDetail: null,
      dataShareDetail: null,
      recommendCode: '',
      canvasUrl: '',
      swiperOption: {
        effect: 'coverflow',
        centeredSlides: true,
        spaceBetween: 10,
        slidesPerView: 'auto',
        loop: false,
        autoplay: false, // 是否自动播放
        touchRatio: 2,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: false
        },

        on: {
          slideChangeTransitionEnd: res => {
            //监听滑动
          }
        }
        // pagination: {
        //   el: '.swiper-pagination',
        //   type: 'fraction'
        // },
      }
    }
  },
  computed: {
    ...mapGetters('args', ['shareCode'])
  },
  mixins: [Body],
  created() {
    console.log('进来活动created了')
    //https://new-wx.ylyk.com/test/ylyk/payment.html#/activity?activityId=15
    this.activityId = this.$route.query.activityId
    this.shareUserId = appUser.userId
    console.log(appUser.userId)
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getDataShare()
  },
  mounted() {
    this.generatePoster()
  },
  methods: {
    // 检查用户
    hasUser() {
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        return false
      }
      return true
    },
    // 微信登录后，再次获取用户数据
    getWXUserAfter_getData() {
      console.log('进微信登录了')
      this.shareUserId = appUser.userId
      setTimeout(() => {
        this.getDataShare()
      })
    },
    //获取分享海报
    getDataShare() {
      activityService
        .activityRecommend({
          activityId: this.activityId
        })
        .then(res => {
          this.dataShareDetail = res
          this.recommendCode = res.recommendCode
          this.$set(this.dataShareDetail, 'canvasObj', [])
          this.dataShareDetail.recommendCodeUrls.forEach(item => {
            this.dataShareDetail.canvasObj.push({ picUrl: item, canvasUrl: item, isGenerate: false })
          })
        })
        .catch(err => {
          this.$toast(err.data.returnMsg)
          Toast.clear()
          this.dialogShow = false
        })

      // this.makeQRcode()

      // setTimeout(() => {
      //   for (let i = 0; i < res.recommendCodeUrls.length; i++) {
      //     this.createImage(i)
      //   }
      // }, 100)
    },
    //生成海报
    generatePoster() {
      //生成图片结束关闭Toast.clear()
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true
      })

      //五秒钟后关闭Toast
      setTimeout(() => {
        Toast.clear()
      }, 6000)
    },

    checkStatus() {
      if (!this.dataDetail || this.dataDetail.activityStatus === 0) {
        this.$toast('活动未开始！')
        return false
      }
      return true
    },
    //生成二维码
    makeQRcode() {
      let shareQrContent = this.dataShareDetail.shareUrl
      if (!shareQrContent) return
      const opts = {
        errorCorrectionLevel: 'H',
        type: 'image/jpeg',
        quality: 0.3,
        margin: 1
      }
      QRCode.toDataURL(shareQrContent, opts).then(url => {
        this.recommendCode = url
      })
    },
    onImageLoad(index) {
      this.createImage(index)
    },
    createImage(index) {
      try {
        const capture = document.getElementById('capture' + index)
        html2canvas(capture, {
          backgroundColor: null,
          useCORS: true,
          width: capture.offsetWidth,
          height: capture.offsetHeight,
          scrollX: 0,
          scrollY: 0,
          x: 0,
          y: 0,
          scale: 4
        })
          .then(canvas => {
            // document.body.appendChild(canvas)
            const dataURL = canvas.toDataURL('image/png')
            this.$set(this.dataShareDetail.canvasObj[index], 'canvasUrl', dataURL)
            this.$set(this.dataShareDetail.canvasObj[index], 'isGenerate', true)
          })
          .finally(() => {
            console.log('生成结束')
            Toast.clear()
          })
      } catch (err) {
        Toast.clear()
      }
    },
    copyText(event) {
      copyText(this.recommendCode, event)
      try {
        //神策数据埋点
        saTrack('recommend_copywriting_click', {
          activity_id: this.dataDetail.activityId,
          copywriting: this.recommendCode,
          operator: '用户本人',
          salesman_id: this.dataShareDetail.adminShareUserId
        })
      } catch (err) {}
      // MessageBox({
      //   title: '',
      //   message: '推荐码复制成功，长按保存海报分享',
      //   confirmButtonText: '我知道了',
      //   confirmButtonClass: 'button-i_see'
      // }).then(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'index.scss';
.tjmbg {
  padding: 10px 15px;
  margin: 0 20px 20px;
  background-color: #fff;
  color: #666;
  border-radius: 4px;
  .tjmtxt {
    font-weight: bold;
    font-size: 22px;
    letter-spacing: 2px;
    color: #000;
  }
}
.longpress {
  color: #333;
  .icon-zhiwen {
    background-image: url('./images/icon_zhiwen_grey.png');
  }
}
.my-swiper {
  position: absolute;
  width: 100vw;
  height: 108vw;
  top: 50%;
  margin-top: -50vw;
}
.swiper-container {
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  overflow: visible !important;
  .swiper-wrapper .swiper-slide {
    width: 81vw;
    border-radius: 8px;
    overflow: hidden;
    transform: none !important;
    height: 98vw;
    margin-top: 5vw;
  }
  .swiper-slide-active {
    height: 100% !important;
    margin-top: 0 !important;
  }
  .swiper-wrapper .swiper-slide img {
    width: 100%;
    height: 100%;
  }
  .swiper-pagination {
    font-size: 28px;
    color: #8a91a4;
    bottom: -80px !important;
  }
}
.qrcode {
  position: absolute;
  left: 50%;
  margin-left: -50px;
  bottom: 36%;
  padding: 5px;
  border-radius: 4px;
  width: 100px;
  height: 30px;
  letter-spacing: 3px;
  color: #fff;
  text-align: center;
  font-weight: bold;
  font-size: 28px;
}
.explain {
  position: fixed;
  top: 40px;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  border-top-left-radius: 24px;
  border-bottom-left-radius: 24px;
  padding: 8px 10px 8px 16px;
  color: #fff;
}
.explain-con {
  border: 5px solid #366c6d;
  border-radius: 8px;
  position: relative;
  height: 80vh;
  margin: 0 20px;
  margin-top: 10vh;
  background: #fff;
  padding: 45px 0px 76px;
  .title {
    position: absolute;
    top: -9px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 120px;
    height: 50px;
    line-height: 42px;
    text-align: center;
    background: url('./images/rule_title_bg.png') no-repeat;
    background-size: 100% auto;
    color: #fff;
    font-size: 16px;
    font-weight: bold;
  }
  .container {
    padding: 0 20px;
    line-height: 22px;
    height: 100%;
    overflow-y: auto;
  }
  .myrule {
    h3 {
      margin-top: 16px;
      margin-bottom: 5px;
      font-size: 16px;
    }
    p {
      font-size: 14px;
      color: #555;
    }
  }
  .know {
    position: absolute;
    background-color: #fff;
    bottom: 0;
    width: 100%;
    padding: 16px;
  }
}
</style>
